'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startPubSub = undefined;

var _initializePubSub = require('conversations-internal-pub-sub/redux/actions/initializePubSub');

var _getToken = require('../clients/getToken');

var _resolveBuilder = require('../resolvers/resolveBuilder');

var _trackUserInteraction = require('../../actions/trackUserInteraction');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _networkOnline = require('../../actions/PubSubStatusActions/networkOnline');

var _networkOffline = require('../../actions/PubSubStatusActions/networkOffline');

var _subscribeToThreadChannels = require('../../actions/ConversationsActions/subscribeToThreadChannels');

var _fetchCurrentThreadHistory = require('../../thread-histories/actions/fetchCurrentThreadHistory');

var _ThreadActions = require('../../threads/actions/ThreadActions');

var _publishAllMessagesInHistoryToChannel = require('../../thread-histories/actions/publishAllMessagesInHistoryToChannel');

var _once = require('transmute/once');

var _once2 = _interopRequireDefault(_once);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startPubSub = exports.startPubSub = function startPubSub() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      publishStagedMessages = _ref.publishStagedMessages,
      channel = _ref.channel,
      threadId = _ref.threadId;

  return function (dispatch, getState) {
    // TODO [Follow up]: Find a better home for this
    dispatch((0, _trackUserInteraction.trackUserInteraction)());

    var clientOptions = {
      authCallback: function authCallback(__tokenParams, callback) {
        (0, _getToken.getToken)({ sessionId: (0, _getSessionId.getSessionId)(getState()) }).then(function (tokenRequest) {
          return callback(null, tokenRequest);
        }, function (error) {
          return callback(error);
        });
      }
    };

    var publishRecentlyCreatedThreadMessages = (0, _once2.default)(function () {
      dispatch((0, _publishAllMessagesInHistoryToChannel.publishAllMessagesInHistoryToChannel)({ channel: channel, threadId: threadId }));
    });

    var lifecycleHooks = {
      onConnect: function onConnect(_ref2) {
        var connectionWasSuspended = _ref2.connectionWasSuspended;

        dispatch((0, _networkOnline.networkOnline)());
        dispatch((0, _subscribeToThreadChannels.subscribeToThreadChannels)());

        // TODO [Follow up]: Remove this when messages can be posted to the thread create endpoint
        if (publishStagedMessages) {
          publishRecentlyCreatedThreadMessages();
        }

        if (connectionWasSuspended) {
          dispatch((0, _fetchCurrentThreadHistory.fetchCurrentThreadHistory)());
          dispatch((0, _ThreadActions.fetchVisitorThreads)());
        }
      },
      onDisconnect: function onDisconnect() {
        dispatch((0, _networkOffline.networkOffline)());
      },
      onFailure: function onFailure() {
        dispatch((0, _networkOffline.networkOffline)());
      }
    };

    dispatch((0, _initializePubSub.initializePubSub)({ clientOptions: clientOptions, lifecycleHooks: lifecycleHooks, resolveBuilder: _resolveBuilder.resolveBuilder }));
  };
};